<template>
<section v-if="hasPermissions(['Report Read', 'Report Write'])" class="view">
    <Breadcrumb :breadcrumb="breadcrumb" />
    <h1 class="view__title title--1" v-html="title_page" />
    <div class="view__description">
        <p class="view__description__text">
        </p>
    </div>
    <div class="tab-content mt-5" v-show="pdfSource">
        <div class="tab-pane fade active show" id="listation">
            <div class="row mb-0 no-gutters justify-content-md-center">
                <div class="col-md-12">
                    <button @click="getReport('xlsx')" class="mx-md-0 modal__buttons__item w-auto px-3 float-right" v-html="'Export to xlsx'"/>
                </div>
                <div class="col-lg-10 mt-5" style="min-height: 60rem">
                    <v-card style="height: 100%">
                        <div>
                            <iframe style="width: 100%; height: 60rem;" :src="pdfSource"></iframe>
                        </div>
                    </v-card>
                </div>
            </div>
        </div>
    </div>
    <WaitingModal />
</section>

<div v-else>
    <UnauthorizedComponent :breadcrumb="breadcrumb" />
</div>
</template>

        
    
<script>
import axios from 'axios';
import Resources from './resources'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal'
import UnauthorizedComponent from '@/components/UnauthorizedComponent'
import { Notyf } from 'notyf'
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'
import moment from 'moment'
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: "DefaultProjectTask",

    components: {
        Breadcrumb,
        WaitingModal,
        UnauthorizedComponent,
    },

    data() {
        return {
            notyf,
            axios,
            user: this.get_user(),
            title_page: 'Reports',
            rest_api: `search_standard_reports`,
            title: 'Default Project Task Frequency Report',
            current_url: `/reports`,
            breadcrumb: JSON.parse(JSON.stringify(Resources.breadcrumb)),
            table_headers: Resources.table_headers,
            pdfSource: '',
            moment
        };
    },

    methods: {

        backToReports() {
            window.location.href = '/reports'
        },

        async getReport(format = 'portrait') {
            const form_data = {
                standard_report_id: 28,
                headers: this.table_headers,
                format
            }

            this.loader(true)

            const response = await this.post('search_standard_reports', form_data)

            if (response.status) 
            {
                if(format !== 'xlsx')
                {
                    const base64Data = await this.downloadFile(response, true)
                    var blobUrl = URL.createObjectURL(base64Data);
                    this.pdfSource = blobUrl
                }
                else
                {
                    this.downloadFile(response)
                }
            } else {
                this.error_handling(response)
            }

            this.loader(false)
        },

    },

    async mounted() {
        if (this.hasPermissions(['Report Read'])) {
            this.getReport()

            this.breadcrumb.push({
                name: 'Default Project Task Frequency Report',
                href: 'default-project-task-frequency-report',
                arrow: '',
            }, )
        }
    },

}
</script>
